import axios, { AxiosInstance, AxiosError } from 'axios';
import { getIdToken } from '../utils/firebase';
import { normalizeErrorPayload } from '../utils/apiError';
import { parsePaywallError } from '../utils/paywall';
import { paywallBus } from '../utils/paywallBus';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const isDev = process.env.NODE_ENV === 'development';

// Create axios instance
const api: AxiosInstance = axios.create({
  baseURL: `${API_URL}/api/v1`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  async (config) => {
    const token = await getIdToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const role = sessionStorage.getItem('nyayabodh_active_role');
    if (role) {
      config.headers['X-Active-Role'] = role;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Guarantee `detail` is renderable before any component touches it. See
    // utils/apiError.ts — an object here used to crash the page via React
    // rather than show the lawyer what actually went wrong.
    normalizeErrorPayload(error.response?.data);
    // Every 402 reaches GlobalPaywallHost, so a lapsed lawyer is offered
    // Renew on whatever page they are on — not a generic error.
    if (error.response?.status === 402) {
      const info = parsePaywallError(error);
      if (info) paywallBus.publish(info);
    }
    if (error.response?.status === 401) {
      window.location.href = '/';
    }
    if (isDev) {
      console.error('API Error:', error.response?.status, error.config?.url);
    }
    return Promise.reject(error);
  }
);

export default api;
